import "./App.css";
import Form from "./components/Form";
import Navbar from "./components/Navbar";


function App() {
  return (
    <>
    <div className="body">
      <Navbar />
      <div className="container">
        <Form />
      
      
      </div>
      </div> 
   
    </>
  );
}

export default App;
